import api from './api'
import {message} from 'antd'

let sendMessageTowxSmallProgram = (data, text) => {
    let obj = {
        srid: data.requestId,
        msg: JSON.stringify(data)
    };
    return new Promise((resolve, reject) => {
        api('/txfit/send_custom_msg_to_wx')
            .post(obj)
            .then(response => {
                message.success(text || '发送成功');
                resolve();
            }).catch(err => {
            message.success(text || '发送失败');
            resolve();
        })
    });
}

let sendLossAssOption = (data) => {
    let sendData = Object.assign({}, {subType: 'lossAssOption'}, data)
    sendMessageTowxSmallProgram(sendData, '查勘意见推送成功')
}

let sendHHLossAssOption = (data) => {
    let sendData = Object.assign({}, {subType: 'lossAssOption'}, data)
    sendMessageTowxSmallProgram(sendData, '电子定损单推送成功')
}

let sendLossElectricPic = (data) => {
    let sendData = Object.assign({}, {subType: 'lossElectricPic'}, data)
    sendMessageTowxSmallProgram(sendData, '电子查勘单推送成功')
}
const sendDeflossPreview = (data) => {
    let sendData = Object.assign({}, {subType: 'deflossPreview'}, data)
    sendMessageTowxSmallProgram(sendData, '定损预览推送成功')
}

const sendTrtcMessageTowxSmallProgram = (params, text) => {
    var data = {
        requestId: params.requestId,
        msg: JSON.stringify(params)
    }
    api('/lossAss/serviceRequests/trtcMsg')
    .post(data)
    .then(response => {
        if (response.errCode === 0) {
            message.success(text || '发送成功')
        } else {
            message.error('发送失败' || response.errInfo)
        }
    }).catch(err => {
        message.success(text || '发送失败')
    })
}

const sendMessageStartStream = (body) => {
    api('/lossAss/serviceRequests/startTrtcStream')
    .post(body).then(response => {
        if (response.errCode !== 0) {

        }
    }).catch(err => {

    })
}

export {
    sendTrtcMessageTowxSmallProgram,
    sendMessageTowxSmallProgram,
    sendLossAssOption,
    sendLossElectricPic,
    sendHHLossAssOption,
    sendDeflossPreview,
    sendMessageStartStream,
}
